import React from "react";
import { Button, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { MdAddCircleOutline, MdCloudDownload } from "react-icons/md";

/**
 * Shown before the stepper when fetch integrations exist; user picks how to start.
 */
export default function NewOrderEntryGate({ onCreateNew, onImportExternal }) {
  const cardProps = {
    flex: 1,
    h: "auto",
    minH: "160px",
    py: 10,
    px: 6,
    variant: "outline",
    borderWidth: "2px",
    borderColor: "gray.200",
    borderRadius: "xl",
    bg: "white",
    _hover: {
      borderColor: "primary.main",
      bg: "orange.50",
      boxShadow: "md",
    },
  };

  return (
    <VStack
      spacing={6}
      align="stretch"
      maxW="720px"
      mx="auto"
      py={{ base: 8, md: 12 }}
      px={2}
    >
      <Text textAlign="center" color="gray.600" fontSize="md">
        Choose how you want to start this order
      </Text>
      <HStack
        spacing={4}
        align="stretch"
        flexDir={{ base: "column", sm: "row" }}
      >
        <Button
          {...cardProps}
          onClick={onCreateNew}
          aria-label="Create new order"
        >
          <VStack spacing={3}>
            <Icon as={MdAddCircleOutline} boxSize={12} color="gray.800" />
            <Text fontWeight="semibold" fontSize="md" textAlign="center">
              Create new
            </Text>
            <Text fontSize="sm" color="gray.500" textAlign="center" fontWeight="normal">
              Enter client details in the form
            </Text>
          </VStack>
        </Button>
        <Button
          {...cardProps}
          onClick={onImportExternal}
          aria-label="Import from external source"
        >
          <VStack spacing={3}>
            <Icon as={MdCloudDownload} boxSize={12} color="gray.800" />
            <Text fontWeight="semibold" fontSize="md" textAlign="center">
              Import from external source
            </Text>
            <Text fontSize="sm" color="gray.500" textAlign="center" fontWeight="normal">
              Fetch data using a saved integration
            </Text>
          </VStack>
        </Button>
      </HStack>
    </VStack>
  );
}
